import { Identify } from '@amplitude/analytics-browser'
import type { BrowserClient } from '@amplitude/analytics-browser/lib/esm/types'
import type { PropertyValue } from './types'

const lastProperties = new WeakMap<BrowserClient, Map<string, string>>()

export const clearUserPropertiesCache = (instance: BrowserClient): void => {
    lastProperties.delete(instance)
}

/** Auth consumers can opt into per-property dedupe; ordinary analytics calls keep their behavior. */
export const sendUserProperties = (
    properties: Record<string, PropertyValue>,
    instance: BrowserClient | undefined,
    options?: { onlyChanged?: boolean }
): void => {
    if (!instance) return
    const previous = lastProperties.get(instance) ?? new Map<string, string>()
    const entries = Object.entries(properties).filter(([key, value]) => !options?.onlyChanged || previous.get(key) !== JSON.stringify(value))
    if (options?.onlyChanged && !entries.length) return
    const identifyObj = new Identify()
    entries.forEach(([key, value]) => identifyObj.set(key, value))
    instance.identify(identifyObj)
    entries.forEach(([key, value]) => previous.set(key, JSON.stringify(value)))
    lastProperties.set(instance, previous)
}
